import { createScorableTab } from './scorableTabFactory';
import { registerTab } from './tabRegistry';

// Default flow — "In Progress" tab. Candidate has started the test but
// hasn't submitted it yet. Registry key matches the flow-statuses API's
// exact status string ("In Progress") — see FailedTab.jsx's comment.
const InProgressTab = createScorableTab(
  'In Progress',
  'No candidates are currently taking their test.'
);

registerTab({
  stateMachineKey: 'default',
  state: 'In Progress',
  component: InProgressTab,
});

export default InProgressTab;
